// import axios from 'axios';

// const axiosInstance = axios.create({
//   baseURL: process.env.REACT_APP_MAIN_BACKEND,
//   withCredentials: true,
// });

// // Proper request interceptor
// axiosInstance.interceptors.request.use((config) => {
//   // You can modify requests here if needed
//   return config;
// });

// // Response interceptor to handle 401 errors
// // axiosInstance.interceptors.response.use(
// //   (response) => response,
// //   (error) => {
// //     if (error.response?.status === 401) {
// //       // Handle unauthorized error (e.g., redirect to login)
// //       window.location.href = '/login';
// //     }
// //     return Promise.reject(error);
// //   }
// // );

// export default axiosInstance;


import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_MAIN_BACKEND,
  withCredentials: true,
});

// Optional: Add token to request headers if stored in localStorage
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle token expiry or unauthorized
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Clear token from storage
      localStorage.removeItem("token");

      // Optional: Show a message (if using toast or alert system)
      alert("Session expired. Please log in again.");

      // Redirect to login
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
